<template>
  <restore-widget
    :title="$t('title')"
    :items="archivedFlows"
    :restore="doRestore"
    :delete="doDelete"
    :dismiss="dismiss"
    :data-loading="loading"
  />
</template>

<script>
import { isEmpty } from 'lodash/lang'
import { mapState, mapActions } from 'vuex'
import { Modal } from '@argon/app/mixins'
import { NAMESPACE } from '../store'
import { RestoreWidget } from '../../components'

export default {
  name: 'ModalFlowRestore',
  mixins: [Modal],
  components: { RestoreWidget },
  props: {
    orgRef: String
  },
  data() {
    return {
      returnPath: { name: 'flow' }
    }
  },
  computed: {
    ...mapState(NAMESPACE, ['archivedFlows'])
  },
  data: () => ({ loading: true }),
  methods: {
    ...mapActions(NAMESPACE, ['listFlows', 'listArchivedFlows', 'clearArchivedFlows', 'restoreFlows', 'deleteFlows']),
    doRestore(selected) {
      let paths = selected.map((item) => item.uris.self)
      return this.restoreFlows(paths).then(() => {
        this.listFlows({})
      })
    },
    doDelete(selected) {
      let paths = selected.map((item) => item.uris.self)
      return this.deleteFlows(paths).then(() => {
        this.listFlows({})
      })
    }
  },
  mounted() {
    this.listArchivedFlows({})
      .catch(() => {})
      .finally(() => {
        this.loading = false
      })
  },
  destroyed() {
    this.clearArchivedFlows()
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Archived Flows"
  },
  "fr": {
    "title": "Flux archivés"
  }
}
</i18n>
